import { Component } from "react"

export default class extends Component{

    constructor(props, context){
        super(props, context);

        this.getTidalPercentage = this.getTidalPercentage.bind(this);
    }

    getTidalPercentage(max,min,val){
        let range = max - min;
        let startValue = val - min;
        let percentage = ( startValue / range ) * 100;

        let chartHeight = 100;
        let formula = ( chartHeight - (( percentage * chartHeight ) / 100) );

        return (formula);
    }

    render(){
        const { tideCurrentVal, tideScaleMax, tideScaleMin } = this.props;

        return(
            <div>
                <div className="tide-chart">
                    <div className="chart-left">
                        <svg width="100%" height="102" viewBox="0 0 102 102">
                            <defs>
                                <mask id="tidalMask" x="0" y="0">
                                    <rect x="1" y="2" width="100" height="100" style={{fill: "#fff", stroke: "transparent", strokeWidth: 1 }}/>
                                </mask>
                            </defs>
                            <rect x="0" y="1" width="102" height="102" style={{ fill: "#c1c2c3" }}/>
                            <rect x="1" y="2" width="100" height="100" style={{ fill: "#f1f2f3" }}/>
                            <rect x="0" y={ this.getTidalPercentage(tideScaleMax, tideScaleMin, tideCurrentVal) } width="102" height="104" style={{ mask: "url(#tidalMask)", fill: "#61daea", stroke: "#179eb0", strokeWidth: 1 }}/>
                        </svg>
                    </div>
                    <div className="chart-right">
                        <span className="chart-value">{ tideCurrentVal }FT</span>
                    </div>
                </div>
            </div>
        )
    }
}




// WEBPACK FOOTER //
// ./src/components/site/tidalGauge/tidalGauge-component.js